// src/services/AboutAndSustainabilityContentService.js
import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../../utils/axiosBaseQuery"; // Assuming the same custom axiosBaseQuery is used
import {
  GET_ABOUT_US_SUSTAINABILITY_CONTENT,
  
  UPDATE_ABOUT_US_SUSTAINABILITY_CONTENT,
  FAQ_PAGE_CONTENT_DETAIL,
  FAQ_PAGE_UPDATE
} from "../../config/constants"; // Adjust endpoints as per your config

const FaqPageContentService = createApi({
  reducerPath: "FaqPageContentService",
  baseQuery: axiosBaseQuery({ baseUrl: "" }), // Use axiosBaseQuery
  tagTypes: ["FaqPageContent"],
  endpoints: (builder) => ({
    getFaqPageContentDetails: builder.query({
      query: (bodyData) => ({
        url: FAQ_PAGE_CONTENT_DETAIL, // Endpoint to fetch settings list
        data: bodyData, // Pass the body data for the request
      }),
      providesTags: ["FaqPageContent"],
    }),
    updateFaqPageContent: builder.mutation({
      query: ({ updatedData }) => ({
        url: `${FAQ_PAGE_UPDATE}`, // Endpoint to update a settings
        method: "PUT",
        data: updatedData, // Updated settings data
      }),
      invalidatesTags: ["FaqPageContent"],
    }),
  }),
});

// Export hooks for usage in functional components
export const {
  useGetFaqPageContentDetailsQuery,
  useUpdateFaqPageContentMutation,
} = FaqPageContentService;

// Export the reducer to be included in the store
export default FaqPageContentService;
